let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ShB2")).then(() => parcelRequire('8a7MV'));